/**
 * Component that allows access to the route if a specific condition is met
 * or displays the UnauthorizedPage (or another specified component) otherwise.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import UnauthorizedPage from '../../../UnauthorizedPage/UnauthorizedPage';

const propTypes = {
  conditionFn: PropTypes.func.isRequired,
  render: PropTypes.func,
  fallbackComponent: PropTypes.func,
};

const defaultProps = {
  render: null,
  fallbackComponent: UnauthorizedPage,
};

function ConditionalRoute({ conditionFn, render, fallbackComponent, ...rest }) {
  let props = rest;
  if (!conditionFn()) {
    props = { ...props, component: fallbackComponent };
    return <Route {...props} />;
  }
  return <Route render={render} {...props} />;
}

ConditionalRoute.propTypes = propTypes;
ConditionalRoute.defaultProps = defaultProps;

export default ConditionalRoute;
